import { AnchorHTMLAttributes, ReactNode, useRef } from 'react';
import { toast } from 'react-toastify';

import { Toast, ToastAction, ToastProps } from '@/Components/Toast';

type ToastConfig = {
    variant: ToastProps['variant'];
    action?: ToastAction;
    label: string;
    autoClose?: number | false;
};

export function useToast() {
    const showToast = useRef((config: ToastConfig) => {
        toast<ToastProps>(
            (props) => (
                <Toast
                    {...props}
                    action={config.action}
                    variant={config.variant}
                    label={config.label}
                />
            ),
            {
                autoClose: 'autoClose' in config ? config.autoClose : 3000,
                draggable: false,
                pauseOnHover: false,
                pauseOnFocusLoss: false,
                hideProgressBar: true,
                closeButton: false,
                position: 'top-right',
            },
        );
    }).current;

    return {
        showToast,
        hideToast: toast.dismiss,
    };
}
